// extracted by mini-css-extract-plugin
export default {"icons":"BusinessData_icons__lI-vJ"};